import React from 'react';
import {Box} from '@mui/material';
import {ArrDrawer} from '../../../../common/arr-drawer/ArrDrawer';
import EditPanelContainer from './EditPanelContainer';

type CommonPanelProps = {
  showdrawer: boolean;
  onDrawerClose: (value: boolean) => void;
  onSaveConfirm?: () => void;
};

const EditPanelDrawer: React.FC<CommonPanelProps> = ({
  showdrawer,
  onDrawerClose,

  onSaveConfirm,
}) => {
  return (
    <Box className="edit-panel-drawer-container">
      {showdrawer && (
        <ArrDrawer
          transition={300}
          showButton={true}
          isOpen={showdrawer}
          size="large"
          side="right"
          className="edit-panel-drawer"
          onClose={() => onDrawerClose(false)}
          showHeader={false}
          children={
            <>
              <EditPanelContainer
                onDrawerClose={() => {
                  onDrawerClose(false);
                }}
                onSaveConfirm={onSaveConfirm}
              />
            </>
          }
        />
      )}
    </Box>
  );
};

export default EditPanelDrawer;
